// extracted by mini-css-extract-plugin
export var large = "service-grid-module--large--5N8z5";
export var section = "service-grid-module--section--kPU4t";
export var itemGrid = "service-grid-module--itemGrid--Kzk8j";
export var sectionGridItem = "service-grid-module--sectionGridItem--quuY0";
export var text = "service-grid-module--text--J9MTz";
export var image = "service-grid-module--image--eHx4e";
export var imageFigure = "service-grid-module--imageFigure--UHCtE";
export var imageFigureLeft = "service-grid-module--imageFigureLeft--IDkZb";
export var link = "service-grid-module--link--HSOBd";
export var linkWrapper = "service-grid-module--linkWrapper--K9pUP";